import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable no-console */
import { fg } from '@atlaskit/platform-feature-flags';
import { sendPackageOperationalEvent } from '../analytics-client';
import { getBscGlobalState } from '../bsc-global-state';
var LOG_PREFIX = '[browser-storage-controls]';

// Feel free to add more types here, future dev

export var Logger = /*#__PURE__*/function () {
  function Logger() {
    _classCallCheck(this, Logger);
  }
  return _createClass(Logger, null, [{
    key: "info",
    value: function info(message, metadata) {
      console.log("".concat(LOG_PREFIX, ": ").concat(message), metadata ? JSON.stringify(metadata) : '');
    }
  }, {
    key: "error",
    value: function error(message, metadata) {
      console.error("".concat(LOG_PREFIX, ": ").concat(message), metadata ? JSON.stringify(metadata) : '');
    }
  }, {
    key: "errorWithOperationalEvent",
    value: function errorWithOperationalEvent(_ref) {
      var action = _ref.action,
        _ref$attributes = _ref.attributes,
        attributes = _ref$attributes === void 0 ? {} : _ref$attributes,
        message = _ref.message,
        metadata = _ref.metadata;
      try {
        sendPackageOperationalEvent({
          action: action,
          attributes: _objectSpread({
            error: message
          }, attributes)
        });
      } catch (e) {
        this.error("Failed to send operational event on error: ".concat(action, ". ").concat(e.message || ''));
      }
      this.error(message, metadata ? JSON.stringify(metadata) : '');
    }
  }, {
    key: "warn",
    value: function warn(message, metadata) {
      console.warn("".concat(LOG_PREFIX, ": ").concat(message), metadata ? JSON.stringify(metadata) : '');
    }

    /**
     * Logger for additional debugging of the package. Debug logs are only sent when the
     * atl-bsc-debug-mode cookie is set on the browser. This is evaluated via global state
     */
  }, {
    key: "debug",
    value: function debug(message, metadata) {
      if (getBscGlobalState().packageDebugMode && fg('platform_moonjelly_bsc_debug_mode')) {
        console.debug("".concat(LOG_PREFIX, ": DEBUG ").concat(message), metadata ? JSON.stringify(metadata) : '');
      }
    }
  }]);
}();